module.exports = __webpack_public_path__ + "static/media/service1.fbbf6863.svg";